'use client';

import { FiCheck } from 'react-icons/fi';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import AvgPaceIcon from './icons/avg-pace-icon';
import { SheetClose } from '@eliadmin/core/src/components/ui/sheet';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

const startSidebarItemsMock = [
  {
    id: 1,
    title: 'text1210',
    status: 'finished',
  },
  {
    id: 2,
    title: 'text1211',
    status: 'not-started',
  },
  {
    id: 3,
    title: 'text1212',
    status: 'not-started',
  },
  { id: 4, title: 'text1213', status: 'not-started' },
  { id: 5, title: 'text1214', status: 'not-started' },
  { id: 6, title: 'text1215', status: 'not-started' },
  {
    id: 7,
    title: 'text1216',
    status: 'not-started',
  },
  {
    id: 8,
    title: 'text1217',
    status: 'not-started',
  },
  { id: 9, title: 'text1218', status: 'not-started' },
  { id: 10, title: 'text1219', status: 'not-started' },
  { id: 11, title: 'text1220', status: 'not-started' },
];

type StartSidebarProps = {
  currentStep: number;
  setStep: (step: number) => void;
  className?: {
    wrapper?: string;
  };
  inSheet?: boolean;
};

export const StartSidebar = ({ currentStep, setStep, className, inSheet }: StartSidebarProps) => {
  const { t } = useTranslations();

  return (
    <div
      className={cn(
        'w-full flex-col gap-3 rounded-lg sm:flex sm:w-[400px] sm:bg-[#FAFAFA] sm:p-5',
        inSheet && 'gap-6',
        className?.wrapper,
      )}
    >
      {startSidebarItemsMock.map(({ id, title, status }) => {
        const statusTransformed = currentStep === id ? 'in-progress' : status;

        if (!inSheet) {
          return (
            <div
              key={id}
              className="flex cursor-pointer items-center justify-start gap-3 py-1"
              onClick={() => setStep(id)}
            >
              <StartSidebarStatusIndicator status={statusTransformed} />
              <h1
                className={cn(
                  'sm:text-lg sm:leading-[25px]',
                  statusTransformed === 'in-progress'
                    ? 'font-semibold sm:max-w-[320px]'
                    : 'font-normal sm:max-w-[306px]',
                )}
              >
                <span
                  style={{
                    display: 'inline-block',
                    whiteSpace: 'normal', // Allows wrapping
                  }}
                >
                  {t(title)}
                </span>
              </h1>
            </div>
          );
        }

        if (inSheet) {
          return (
            <SheetClose
              key={id}
              className="flex cursor-pointer items-center justify-start gap-3 py-1"
              onClick={() => setStep(id)}
            >
              <StartSidebarStatusIndicator status={statusTransformed} />
              <h1
                className={cn(
                  'sm:text-lg sm:leading-[25px]',
                  statusTransformed === 'in-progress'
                    ? 'font-semibold sm:max-w-[320px]'
                    : 'font-normal sm:max-w-[306px]',
                )}
              >
                <span
                  style={{
                    display: 'inline-block',
                    whiteSpace: 'normal', // Allows wrapping
                  }}
                >
                  {title}
                </span>
              </h1>
            </SheetClose>
          );
        }
      })}
    </div>
  );
};

const StartSidebarStatusIndicator = ({
  status,
}: {
  status: 'not-started' | 'in-progress' | 'finished' | string;
}) => {
  return (
    <div
      className={` flex max-h-8 min-h-8 min-w-8 max-w-8 items-center justify-center rounded-full ${
        status === 'not-started'
          ? 'bg-gray-400'
          : status === 'in-progress'
          ? 'bg-black'
          : 'bg-green-400'
      }`}
    >
      {status === 'finished' && <FiCheck className="h-6 w-6 text-white" />}
      {status === 'in-progress' && <AvgPaceIcon className="h-6 w-6 text-white" />}
    </div>
  );
};
